import { useState } from 'react';
import dataService from 'services/dataService';
import useValidation from './useValidation';

const startEditing =
  (setIsEditing, setEditingRowIndex, setRow) => (row, rowIndex) => {
    setIsEditing(true);
    setEditingRowIndex(rowIndex);
    setRow(row);
  };

const closeEditing = (setIsEditing, setEditingRowIndex, setRow) => () => {
  setIsEditing(false);
  setEditingRowIndex(null);
  setRow({});
};

const saveChanges = (setLoading) => async (endpoint, row) => {
  setLoading(true);
  const { data, error } = await dataService.updateOnly(endpoint, row);
  setLoading(false);
  return { data, error };
};

const useEditingTable = (validationRules) => {
  const [loading, setLoading] = useState(false);
  const [isEditing, setEditing] = useState(false);
  const [rowIndex, setEditingRowIndex] = useState(null);
  const { row, setRow, isValid, messageErrors, validate } = useValidation(
    {},
    validationRules,
  );
  const closeEdit = closeEditing(setEditing, setEditingRowIndex, setRow);

  return {
    row,
    rowIndex,
    isEditing,
    loading,
    isValid,
    messageErrors,
    setRow,
    startEditing: startEditing(setEditing, setEditingRowIndex, setRow),
    saveChanges: saveChanges(closeEdit, setLoading),
    closeEditing: closeEdit,
    validate,
  };
};

export default useEditingTable;
